import { lazyLoadView } from '@utils/app/lazy-load-routes'
import store from '@state/store'
import { setInfo } from '@utils/app/select-info'
import toggle from '@utils/design/toggle-info'

export default [
  {
    path: '/interact',
    name: 'Interact',
    component: () => lazyLoadView(import('@views/interact/interact')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('infoDetails/selectDetailsDefault', {
            defaultObject: null,
          }),
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
        ]).then(() => {
          next()
        })
      },
    },
  },
  {
    path: '/interact/activity/',
    name: 'Interact Activity',
    component: () => lazyLoadView(import('@views/interact/interact-activity')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('deviceEventCurrent/fetchEventCurrents', {
            clearCache: true,
          }),
          store.dispatch('deviceActivity/fetchActivities', { clearCache: false }),
          store.dispatch('infoDetails/selectDetailsDefault', {
            defaultObject: null,
          }),
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
        ]).then(() => {
          next()
        })
      },
    },
  },

  {
    path: '/interact/cycle',
    name: 'Interact Cycle',
    component: () => lazyLoadView(import('@views/interact/interact-cycle')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('deviceEventCurrent/fetchEventCurrents', {
            clearCache: true,
          }),
          store.dispatch('deviceCycle/fetchCycles', {
            clearCache: true,
          }),
          store.dispatch('infoDetails/selectDetailsDefault', {
            defaultObject: null,
          }),
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
        ]).then(() => {
          next()
        })
      },
    },
  },
]
